import { render, staticRenderFns } from "./WizardContentClaioSchemaSelector.vue?vue&type=template&id=31f0cd36&scoped=true&"
import script from "./WizardContentClaioSchemaSelector.vue?vue&type=script&lang=ts&"
export * from "./WizardContentClaioSchemaSelector.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentClaioSchemaSelector.vue?vue&type=style&index=0&id=31f0cd36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f0cd36",
  null
  
)

export default component.exports